<template>
  <main class="dashboard user-infos">
    <div class="container-fluid container-fluid--max">
      <h1 class="d-none">Mes informations</h1>
      <div class="dash-infos row">
        <section class="user-infos__profile col-lg-4">
          <div class="dash-infos__card card">
            <div class="card-body">
              <h2 class="dash-infos__title heading-secondary">Profil</h2>
              <div class="dash-infos__content text-center align-items-center mt-lg-3 row">
                <div class="dash-infos__img-wrapper col-auto col-lg-12 mb-lg-3 mx-lg-auto">
                  <img class="dash-infos__img img-fluid" :alt="currentUser.avatar.filename" :src="currentUser.avatar.url" v-if="currentUser.avatar">
                  <img class="dash-infos__img img-fluid" alt="Image du profil" :src="require(`@/assets/images/logo-${$appName}.jpg`)" v-else>
                </div>
                <div class="col-sm col-lg-12">
                  <h3 class="heading-primary">{{ currentUser.name }}</h3>
                  <div class="dash-infos__details thin">
                    <p class="mb-0">{{ currentUser.email }}</p>
                    <p class="mb-0">{{ currentUser.phone }}</p>
                  </div>
                </div>
                <div class="col-md col-lg-12 mt-3 mt-md-0 mt-lg-3">
                  <router-link :to="{ name: 'userEditProfile' }" class="btn btn-block" :class="'btn-' + $mainColor">
                    Modifier mes informations
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="user-infos__company col-lg-8 mt-4 mt-lg-0">
          <div class="card">
            <div class="card-body d-flex flex-column">
              <h2 class="dash-infos__title heading-secondary">Mon entreprise</h2>
              <div class="row h-100">
                <div class="col-md-5 text-center d-flex flex-column justify-content-between">
                  <div>
                    <div v-if="center">
                      <div class="my-2">
                        <span class="fa-stack fa-lg small mr-h">
                          <i class="fa fa-circle fa-stack-2x" :class="'text-' + $mainColor"></i>
                          <i class="fa fa-building-o fa-stack-1x fa-inverse"></i>
                        </span>
                        <h3 class="heading-primary d-inline align-middle">{{ center.name }}</h3>
                      </div>
                      <p class="mb-0 thin">N° TVA : {{ center.vat_number }}</p>
                    </div>
                    <hr class="w-25 mx-auto" :class="'bg-' + $mainColor">
                    <div class="thin mb-3" v-if="center">
                      <p class="mb-0">{{ center.phone }}</p>
                      <p class="mb-0">{{ center.email }}</p>
                      <p class="mb-0">{{ center.full_address }}</p>
                    </div>
                  </div>
                  <router-link :to="{ name: 'userEditCompany' }" class="btn btn-block" :class="'btn-' + $mainColor">
                    {{ companyTitleButton }}
                  </router-link>
                </div>
                <div class="col-md-7 mt-4 mt-md-0" v-if="center && center.located">
                  <Gmap :lat="center.lat" :lng="center.lng" id="company" class="h-100" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import Gmap from '@/components/ui/Gmap'
import { mapState } from 'vuex'

export default {
  name: 'Profile',
  components: {
    Gmap
  },
  computed: {
    ...mapState(['currentUser']),
    center () {
      return this.currentUser.center
    },
    companyTitleButton () {
      if (this.currentUser.center) return 'Éditer mon entreprise'
      else return 'Enregistrer mon entreprise'
    }
  }
}
</script>
